jQuery(function ($) {
	//Styled input Labels
	$('.field.text:not(.date-alt):not(.date):not(.time), .field.textarea').each(
		function () {
			var $this = $(this);
			if ($this.closest('form').hasClass('no-dynamic-labels')) {
				return;
			}
			var $field = $this.find('input, textarea');
			var $fieldLabel = $this.children('label.left');
			$this.addClass('dynamic-label');
			$field
				.focus(function () {
					$fieldLabel.addClass('filled');
				})
				.change(function () {
					if ($field.val() === '') {
						$fieldLabel.removeClass('filled');
					} else {
						$fieldLabel.addClass('filled');
					}
				})
				.blur(function () {
					if ($field.val() === '') {
						$fieldLabel.removeClass('filled');
					} else {
						$fieldLabel.addClass('filled');
					}
				})
				.blur();
		}
	);
});
